import InvalidStore from './InvalidStore';

export default InvalidStore;
